import { eventTiles, getSelectedTiles } from './config'

export const toggleTileSelection = (selectedTileIds, tile) => {
    if (selectedTileIds.includes(tile.id)) {
        return selectedTileIds.filter(tileId => tileId !== tile.id)
    }

    const incompatibleTileIds = new Set(tile.incompatibleWith)
    eventTiles.forEach(candidateTile => {
        if (candidateTile.incompatibleWith.includes(tile.id)) incompatibleTileIds.add(candidateTile.id)
    })

    return [...selectedTileIds.filter(tileId => !incompatibleTileIds.has(tileId)), tile.id]
}

export const createEventCreatorPayload = ({ selectedTileIds, description }) => ({
    selectedTiles: getSelectedTiles(selectedTileIds),
    description,
})
